// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"200":"df14436e","294":"f9623445","848":"8c5d4ca8","943":"8c5d4ca8"}[chunkId] + ".chunk.css";
};